// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import Vue from 'vue';
import ajax from './utils/ajax.js';
import sleep from './utils/sleep.js';
import App from './App';
import router from './router';
import store from './store';
import directives from './directives';
import androidpc from './utils/androidCallback.js'
import urlAPI from './config/urlApi'
import vueTap from 'v-tap';
import element from '../static/element-ui/lib/index.js';
Vue.use(vueTap);
Vue.use(directives);
Vue.use(ajax);
Vue.use(sleep);
Vue.use(androidpc);
Vue.use(urlAPI);
Vue.use(element);
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {App}
});



// WEBPACK FOOTER //
// ./src/main.js